import type { LicensedProducts } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

export const licensedProductsToString: (arg1: LicensedProducts) => string = (licensedProducts) =>
	Object.keys(licensedProducts)
		.map((productKey) => (licensedProducts[productKey] ? productKey : ''))
		.join(', ');
